export default {
    namespaced: true,
    state: {
        cp_uid: process.env.NAV_CP_UID
    },
    mutations: {

    },
    actions: {

    },
    getters: {

    }
}


// WEBPACK FOOTER //
// ./src/store/moduleA.js